import React from 'react';
import { times, isValidPostcode, waitFor, empty } from '../../../../Shared/Assets/utils';
import EventBus, {EventName} from '../../../../Shared/Assets/event-bus';

export default class PostCodeInput extends React.Component {
  constructor(props) {
    super(props);
    this.digitCount = 4;

    this.elements = [];
    times(this.digitCount)
      (i => this.elements.push(React.createRef()));

    this.props = props;
    this.eventBus = new EventBus();
    this.initState(props);
    this.eventBus.handle(EventName.PostCodeChanged, this._handlePostcodeChanged);
  }

  _handlePostcodeChanged = (eventData) => {
    if (eventData.postcode !== "") {
      let newState = {};

      for (let i = 0; i < 4; i++) {
        if (eventData.postcode.length > i) {
          newState["digit" + i] = eventData.postcode[i];
        }
        else {
          newState["digit" + i] = "";
        }
      }
      this.setState(newState);
    }
  }

  initState = props => {
    let postcode = props.postcode;
    if (empty(props.postcode) && !empty(props.postcodeElement)) {
      postcode = props.postcodeElement.value;
      this.eventBus.dispatch(EventName.PostCodeChanged, {postcode: postcode});
    }

    let stateObj = {};
    times(this.digitCount)
      (i => stateObj['digit' + i] = postcode[i] || "");
    this.state = stateObj;
  }

    setValue = evt => {
      let index = parseInt(evt.target.getAttribute("data-index"));
      if (evt.nativeEvent.inputType == "deleteContentBackward") {
          this.setDigitValue(index, "");
          this.moveNext(index);
          return;
      }

      if (isNaN(parseInt(evt.nativeEvent.data)))
          return;

      this.setDigitValue(index, evt.target.value, this.postcodeChanged);
      this.moveNext(index + 1);
  }

  setDigitValue = (index, value, callback) => {
    let newState = {};
    newState["digit" + index] = value;
    this.setState(newState, callback);
  }

  postcodeChanged = () => {
    let postcode = "";
    times(this.digitCount)
      (i => {
        postcode += this.state['digit' + i] + "";
      });
    if (this.props.postcodeChanged && typeof(this.props.postcodeChanged) === 'function') {
      this.props.postcodeChanged(postcode);
    }

    // fired an event for postcode change so other react components can handle
    this.eventBus.dispatch(EventName.PostCodeChanged, {postcode: postcode});
  }

  fireUpdatePostcodeTrackingEvent() {
    waitFor(() => {
      if (typeof window.webmClickTracking === 'function')
        return true;
      return false;
    }, 500, 3)
    .then(success => {
      if (typeof dcsMultiTrack === "function") {
        dcsMultiTrack('WT.dl', '99', 'WT.nv', 'Availability', 'WT.z_ti', 'Update Postcode', 'WT.z_pg', 'BNC Details');
      }
    });
  }

  moveNext = index => {
    if (index < this.digitCount && index >= 0) {
      let newState = {};
      for (let i = index; i < this.digitCount; i++) {
        newState['digit' + i] = "";
      }
      this.setState(newState);
      this.elements[index].current.focus();
    }
  }

  selectText = evt => {
    let index = parseInt(evt.target.getAttribute("data-index"));
    this.elements[index].current.select(0, 1);
  }

  render() {
    const inputList = [];
    times(this.digitCount)
      (i => {
        let state = this.state['digit' + i];
        inputList.push(<input key={i.toString()} type="text" maxLength="1" ref={this.elements[i]}
            value={state} onChange={this.setValue} data-index={i}
          onFocus={this.selectText} />);
      });

    return (
      <div className="postcode-panel-section clearfix">
        <label>Enter postcode to continue</label>
        <div className="postcode-input-wrapper">
          {inputList}
        </div>
      </div>
    );
  }
}